import { render, staticRenderFns } from "./RegulationSection.vue?vue&type=template&id=c2cbea06&scoped=true"
import script from "./RegulationSection.vue?vue&type=script&lang=js"
export * from "./RegulationSection.vue?vue&type=script&lang=js"
import style0 from "./RegulationSection.vue?vue&type=style&index=0&id=c2cbea06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_4o2rd25vzlqqqsloupejyolan4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cbea06",
  null
  
)

export default component.exports